// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioButton_root__LlzFR","label":"RadioButton_label__7hS9J"};